import React, { Component } from "react";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import NavigationClose from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import MenuIcon from "@material-ui/icons/Menu";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { pushBottomPanel } from "../actions/dashboard";
import ContentRightpanel from "../granular/Portal/rightpanel";
import ContentBottompanel from "../granular/Portal/bottompanel";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

class Bottompanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bottom: this.props.bottomPanel
    };
  }
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ bottom: nextProps.bottomPanel });
  }

  handleRighpanelClose = () => {
    this.props.pushBottomPanel(!this.state.bottom);
  };

  contentBt = () => {
    if (this.state.bottom) {
      return <ContentBottompanel />;
    } else {
      return false;
    }
  };

  render() {
    return (
      <Drawer
        anchor="bottom"
        variant="persistent"
        open={this.state.bottom}
      >
        {this.contentBt()}
      </Drawer>
    );
  }
}

Bottompanel.propTypes = {
  classes: PropTypes.object.isRequired,
  bottomPanel: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    bottomPanel: state.bottomPanel
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushBottomPanel }
  )(Bottompanel)
);
